import "./CardPorServicios.scss";

const WHATSAPP_NUMERO = "5492954396316";

const crearLinkWhatsapp = (tematica) => {
  const mensaje = `Hola, quiero consultar sobre ${tematica.titulo}.`;
  return `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(mensaje)}`;
};

function CardPorServicios({
  titulo = "¿En qué podemos ayudarte?",
  subtitulo = "Elegí la temática que más se relaciona con lo que necesita tu negocio.",
  tematicas = [],
  onSeleccionar,
}) {
  return (
    <section className="tematicas">
      <div className="tematicas-container">
        <div className="tematicas-grid">
          {tematicas.map((tematica) => (
            <a
              className="tematica-card"
              key={tematica.id}
              href={crearLinkWhatsapp(tematica)}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Consultar por WhatsApp sobre ${tematica.titulo}`}
              style={{ "--tematica-color": tematica.color || "#891594" }}
              onClick={() => onSeleccionar?.(tematica)}
            >
              <div className="tematica-imagen">
                <img src={tematica.imagen} alt={tematica.titulo} />
                <div className="tematica-overlay" />
              </div>

              <div className="tematica-contenido">
                <h3>{tematica.titulo}</h3>
                <p>{tematica.descripcion}</p>

                <div className="tematica-link">
                  CONSULTAR
                  <span>→</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CardPorServicios;